import { Box, Typography } from '@mui/material';
import pageNotFoundImage from '../../assets/images/pagenotfound.png';
import CommonButton from '../../component/button/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const PageNotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: 'column'
                }}
            >
                <img src={pageNotFoundImage} alt="Not found" />
                <Typography variant='h4' sx={{
                    fontSize: "2.5rem",
                    font: 'Poppins',
                    fontWeight: 700,
                    textAlign: "center",
                    paddingTop: '1.5rem'
                }}>
                    {t('notfound_title')}
                </Typography>
                <Typography sx={{
                    font: 'Poppins',
                    textAlign: "center",
                    paddingTop: '1.5rem',
                    color: "#90909A"
                }}>
                    {t('notfound_description_one')} <br />
                    {t('notfound_description_two')}
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        paddingTop: '1.5rem',
                    }}
                >
                    <CommonButton
                        text={t("notfound_go_to_home")}
                        onClick={() => navigate('/')}
                        type="button"
                        className="add-user-btn"
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default PageNotFound;
